import { HTTP } from "@/utils/http-common"
export default {
  create: function($, file) {
    return new Promise((resolve, reject) => {
      var formData = new FormData()
      formData.append("file", file)

      HTTP.post(`/files/manage/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
